import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Container from "./components/Container";
import Grid from "./components/Grid";
import ProviderCard from "./components/ProviderCard";
import EmptyState from "./components/EmptyState";
import { CATEGORIES } from "./categories";
import { serviceSearch } from "./api";
import styles from "./pages/Results.module.css";

const labelFor = (value) => CATEGORIES.find((c) => c.value === value)?.label || value;

const extractRating = (row) => {
  const key = Object.keys(row).find(
    (k) => k.toLowerCase().includes("rating") || k.toLowerCase().startsWith("avg")
  );
  return key ? Number(row[key]) || 0 : 0;
};

export default function List() {
  const history = useHistory();
  const service = localStorage.getItem("listservice") || "";
  const pincode = localStorage.getItem("listpincode") || "";
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await serviceSearch({ service_category: service, pincode });
        setRows(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.log(error);
        setRows([]);
      } finally {
        setLoaded(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const providers = rows.filter((r) => r && r.username);

  return (
    <div>
      <Nav />
      <main className={styles.page}>
        <Container>
          <div className={styles.head}>
            <h1 className={styles.title}>{labelFor(service)} in {pincode || "your area"}</h1>
            <p className={styles.muted}>Top-rated providers matching your search.</p>
          </div>

          {providers.length > 0 ? (
            <Grid min="280px">
              {providers.map((p, i) => (
                <ProviderCard
                  key={`${p.username}-${i}`}
                  name={p.username}
                  trade={labelFor(service)}
                  pincode={pincode}
                  phone={p.u_phoneno}
                  rating={extractRating(p)}
                  onReview={() => {
                    localStorage.setItem("reviewname", p.username);
                    history.push("/rateandcomment");
                  }}
                />
              ))}
            </Grid>
          ) : (
            loaded && (
              <EmptyState
                title="No services found"
                message="No providers matched this service and pincode. Try a different pincode."
              />
            )
          )}
        </Container>
      </main>
      <Footer />
    </div>
  );
}
